import React from 'react';
import Dialog from 'lib/components/Dialog';
import { COMMON_MSG, ERROR_MSG } from 'lib/constants/error';
import './index.scss';

const OrderFail = ({ code }) => (
  <Dialog title="订购申请失败" confirmButtonText="知道了">
    <div className='order-fail-msg'>{ERROR_MSG[code] || COMMON_MSG}</div>
  </Dialog>
);

export default OrderFail;
